// method to format date
import formatDate from './../../scripts/reusable/format-date'

const parseResStringName = (str) => {
  return str.match(new RegExp('{!tag=(.*)}'))[1]
}

const parseStringDate = (str, name) => {
  // parse list of subfilters
  let tempResults = str.replace(/{!tag=(.*)}/, '')
  // parse from and to date
  tempResults = tempResults.replace(new RegExp(name + ':'), '')
  tempResults = tempResults.match(/\[(.*?)\]/)[1]
  tempResults = tempResults.split(' ')

  // returns starting and ending date and information if date is set
  return {
    from: formatDate(tempResults[0]),
    to: formatDate(tempResults[2])
  }
}

const parseResString = (str, name) => {
  let results = []
  // parse list of subfilters
  let tempResults = str.replace(/{!tag=(.*)}/, '')
  tempResults = tempResults.match(new RegExp(name + ': \"' + '(.*?)' + '\"', "gi"))

  function addRes(element) {
    // push every filter to array of filters
    results.push(element.match(name + ': \"' + '(.*)' + '\"', "gi")[1])
  }
  tempResults.forEach(addRes)

  // returns name of filter and array of its subfilters
  return {
    name: name,
    filters: results
  }
}

export {
  parseResStringName,
  parseStringDate,
  parseResString
}



// WEBPACK FOOTER //
// ./src/store/reusable/fq-parser.js